import React from "react";
import { Link } from "react-router-dom";
import "./ProductCard.css";
import { FaMapMarkerAlt } from "react-icons/fa";

// Hàm tiện ích để định dạng tiền
const formatPriceVND = (price) => {
    if (!price) return "Thỏa thuận";
    return new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
    }).format(price);
};

// Hàm tiện ích để lấy Quận/Huyện từ địa chỉ dài
const getDistrict = (address) => {
    if (!address) return "Không rõ";
    const parts = address.split(",").map((part) => part.trim());
    // Thường thì Quận/Huyện sẽ ở vị trí thứ 2 từ cuối lên
    if (parts.length >= 2) {
        return parts[parts.length - 2];
    }
    return address; // Trả về địa chỉ gốc nếu không parse được
};

const ProductCardNew = ({ product }) => {
    // API không có ảnh, ta dùng ảnh placeholder
    const placeholderImage = product.Thumbnail || product.avatar_link ||
        "https://via.placeholder.com/300x200.png?text=No+Image";
    const title = product.Title || product.title || product.Name || product.name || "(Không có tiêu đề)";
    const price = product.Price || product.price || product.amount || product.cost;
    const address = product.Address || product.address || product.location || product.city;
    const productID = product.ListingID || product.id || product.ID;

    return (
        <Link to={`/market/detail-new/${productID}`} className="product-card-link">
            <div className="product-card-container">
                <div className="product-image-wrapper">
                    <img
                        src={placeholderImage}
                        alt={title}
                        className="product-main-image"
                    />
                </div>
                <div className="product-info-wrapper">
                    <h3 className="product-title-text">{title}</h3>
                    <div className="product-meta">
                        {/* API không có, ta thêm tạm */}
                        <span>Tình trạng • Mới</span>
                    </div>
                    <p className="product-price-text">{formatPriceVND(price)}</p>
                    <div className="product-location-wrapper">
                        <FaMapMarkerAlt className="location-icon" />
                        <span>{getDistrict(address)}</span>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default ProductCardNew;
